module.exports = __webpack_public_path__ + "img/docx.de7674a.svg";